import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isValidDomain = [
        'https://portal-ovdim.netlify.app',
        'https://phishing.netlify.app',
        'https://cybersoc.netlify.app',
        'http://localhost:4200',
        'https://my-portals.org',
        'https://www.my-portals.org',

    ].indexOf(window.location.origin) > -1;
    if (isValidDomain) {
      return true;
    } else {
      return this.router.parseUrl('/404');
    }
  }

}
